import { createQueryAtomFactory } from '~/shared/providers/api/createQueryAtomFactory';

export const paymentTermConfigsQueryAtom = createQueryAtomFactory(
  'crm.paymentTermConfigs',
  () => ({
    paymentTermConfigs: {
      __args: {
        pagination: { offset: 0, limit: 100 },
      },
      entries: {
        id: true,
        name: true,
        code: true,
      },
    },
  }),
  {
    select: (data) => ({
      paymentTerms: data?.paymentTermConfigs.entries ?? [],
    }),
  },
);
